(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hh-product-banner"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('hh-product-banner')) return;

  class HHProductBanner extends HTMLElement {
    connectedCallback() {
      this.initFrame = requestAnimationFrame(() => this.init());
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.initFrame);
      cancelAnimationFrame(this.syncFrame);
      cancelAnimationFrame(this.loopFrame);
      clearTimeout(this.clickTimer);
      clearTimeout(this.statusTimer);
      this.abort?.abort();
      this.formObserver?.disconnect();
      this.pageObserver?.disconnect();
      this.resizeObserver?.disconnect();
      this.intersectionObserver?.disconnect();
      this.initialised = false;
    }

    init() {
      if (this.initialised || !this.isConnected) return;
      this.initialised = true;
      this.abort = new AbortController();
      this.button = this.querySelector('[data-add-button]');
      this.buttonLabel = this.querySelector('[data-button-label]');
      this.selection = this.querySelector('[data-selection]');
      this.status = this.querySelector('[data-status]');
      this.viewport = this.querySelector('[data-viewport]');
      this.media = this.querySelector('[data-media]');
      this.track = this.querySelector('[data-track]');
      this.group = this.querySelector('[data-original-group]');
      this.pauseButton = this.querySelector('[data-pause]');
      this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.hoverQuery = window.matchMedia('(hover: hover)');
      this.inView = false;
      this.userPaused = false;
      this.hovered = false;
      this.viewportFocused = false;
      this.awaitingCart = false;
      this.clickLocked = false;
      this.lastError = '';
      this.lastLoopKey = '';
      this.nativeForm = null;
      try {
        this.productData = JSON.parse(this.querySelector('[data-product-data]').textContent);
      } catch (error) {
        this.productData = { id: '', variants: [] };
      }
      this.variants = new Map(this.productData.variants.map(variant => [String(variant.id), variant]));
      this.listen(this.button, 'click', () => this.addToBasket());
      this.listen(document, 'change', () => this.queueSync());
      this.listen(document, 'input', event => {
        if (event.target.form === this.nativeForm) this.queueSync();
      });
      this.listen(window, 'pageshow', () => this.queueSync());
      this.listen(document, 'shopify:section:load', () => this.queueSync());
      this.listen(document, 'shopify:section:unload', () => this.queueSync());
      // The existing H&H product form emits cart:updated after a successful add.
      this.listen(window, 'cart:updated', () => this.onCartUpdated());
      this.listen(document, 'cart:updated', () => this.onCartUpdated());

      // Detect a replaced/late-loaded product form without watching every DOM
      // attribute on the page. Ignore changes inside this banner itself.
      this.pageObserver = new MutationObserver(records => {
        const changedForm = records.some(record => {
          if (this.contains(record.target)) return false;
          return [...record.addedNodes, ...record.removedNodes].some(node =>
            node.nodeType === 1 && (node.matches('form') || node.querySelector('form'))
          );
        });
        if (changedForm || (this.nativeForm && !this.nativeForm.isConnected)) this.queueSync();
      });
      this.pageObserver.observe(document.body, { childList: true, subtree: true });
      this.syncPurchase();
      this.initImages();
    }

    listen(target, type, callback, options = {}) {
      target?.addEventListener(type, callback, { ...options, signal: this.abort.signal });
    }

    setText(element, text) {
      if (element && element.textContent !== text) element.textContent = text;
    }

    showStatus(text, isError = false) {
      clearTimeout(this.statusTimer);
      this.setText(this.status, text);
      if (this.status) this.status.dataset.error = String(isError);
    }

    queueSync() {
      cancelAnimationFrame(this.syncFrame);
      this.syncFrame = requestAnimationFrame(() => {
        if (this.isConnected) this.syncPurchase();
      });
    }

    field(form, name) {
      return form?.elements.namedItem(name) || null;
    }

    isCurrentProductForm(form) {
      if (!(form instanceof HTMLFormElement) || form.closest('hh-product-banner')) return false;
      if (form.closest('dialog, [role="dialog"], quick-add-modal, .quick-add')) return false;
      let path;
      try { path = new URL(form.action, location.href).pathname; } catch (error) { return false; }
      if (!/\/cart\/add(?:\.js)?\/?$/.test(path)) return false;
      const productId = this.field(form, 'product-id')?.value;
      // A stated, non-matching product ID always wins over a stale variant ID.
      if (productId) return String(productId) === String(this.productData.id);
      return this.variants.has(String(this.field(form, 'id')?.value || ''));
    }

    findProductForm() {
      const selector = this.dataset.formSelector?.trim();
      if (selector) {
        try {
          return [...document.querySelectorAll(selector)].find(form => this.isCurrentProductForm(form)) || null;
        } catch (error) { return null; }
      }
      // Prefer the project's custom product-information.liquid, not a card or
      // a recommended product form. Still verify that it is THIS product.
      const preferred = [...document.querySelectorAll('form.prd__form')]
        .find(form => this.isCurrentProductForm(form));
      if (preferred) return preferred;
      return [...document.querySelectorAll('main form[action*="/cart/add"], #MainContent form[action*="/cart/add"]')]
        .find(form => this.isCurrentProductForm(form)) || null;
    }

    findSubmitButton(form) {
      if (!form) return null;
      const candidates = [...form.elements].filter(element =>
        (element instanceof HTMLButtonElement || element instanceof HTMLInputElement) &&
        element.type === 'submit' &&
        !element.closest('.shopify-payment-button, shopify-accelerated-checkout')
      );
      return candidates.find(element => element.classList.contains('prd__atc-btn')) ||
        candidates.find(element => element.name === 'add') || candidates[0] || null;
    }

    bindProductForm() {
      const form = this.findProductForm();
      if (form !== this.nativeForm) {
        this.formObserver?.disconnect();
        this.nativeForm = form;
        this.lastError = '';
        if (form) {
          this.formObserver = new MutationObserver(() => this.queueSync());
          this.formObserver.observe(form, {
            subtree: true, childList: true, characterData: true, attributes: true,
            attributeFilter: ['disabled', 'aria-disabled', 'aria-busy', 'value', 'hidden', 'class']
          });
        }
      }
      this.nativeButton = this.findSubmitButton(form);
    }

    syncPurchase() {
      this.bindProductForm();
      if (!this.button) return;
      const idField = this.field(this.nativeForm, 'id');
      const variant = this.variants.get(String(idField?.value || ''));
      const nativeBusy = this.nativeButton?.getAttribute('aria-busy') === 'true' ||
        !!this.nativeButton?.classList.contains('loading');
      const nativeDisabled = !this.nativeButton || this.nativeButton.disabled ||
        this.nativeButton.getAttribute('aria-disabled') === 'true';
      const missingSelection = !variant || !!idField?.disabled;
      const soldOut = variant ? !variant.available :
        this.variants.size > 0 && ![...this.variants.values()].some(item => item.available);
      const needsOptions = !this.nativeForm || !this.nativeButton || missingSelection;
      const busy = nativeBusy || this.clickLocked;
      let label = this.button.dataset.label;
      if (busy) label = 'Adding…';
      else if (soldOut) label = 'Sold out';
      else if (needsOptions) label = 'Choose options';
      this.setText(this.buttonLabel, label);
      this.button.disabled = busy || soldOut || (!needsOptions && nativeDisabled);
      this.button.setAttribute('aria-busy', String(busy));

      const summary = [];
      if (variant && variant.title !== 'Default Title') summary.push(variant.title);
      if (variant) {
        const quantity = this.field(this.nativeForm, 'quantity')?.value || '1';
        summary.push('Quantity: ' + quantity);
        const plan = this.field(this.nativeForm, 'selling_plan')?.value;
        if (plan && plan !== '0') summary.push('Subscription selected');
      }
      this.setText(this.selection, summary.join(' · '));

      // Mirror the project's form errors next to the banner button, so a
      // customer does not have to scroll back to discover an inventory error.
      const errorNode = this.nativeForm?.querySelector('.prd__form-error, .product-form__error-message');
      const errorText = errorNode && !errorNode.hidden &&
        !errorNode.closest('[hidden]') ? errorNode.textContent.trim() : '';
      if (errorText && errorText !== this.lastError) {
        this.awaitingCart = false;
        this.showStatus(errorText, true);
      } else if (!errorText && this.lastError) {
        this.showStatus('');
      }
      this.lastError = errorText;
    }

    addToBasket() {
      if (this.clickLocked) return;
      this.syncPurchase(); // Read the live form again AT CLICK TIME.
      const idField = this.field(this.nativeForm, 'id');
      const variant = this.variants.get(String(idField?.value || ''));
      if (!this.nativeForm || !this.nativeButton) {
        this.showStatus(this.dataset.designMode === 'true'
          ? 'Keep the Product Page section and Buy Buttons block in this template. The product form was not found.'
          : 'Please use the purchase options on this product page.', true);
        return;
      }
      if (!variant || idField.disabled) {
        this.showStatus('Please choose an available product option first.', true);
        this.focusProductOptions();
        return;
      }
      if (!variant.available || this.nativeButton.disabled || this.nativeButton.getAttribute('aria-disabled') === 'true') return;
      const plan = this.field(this.nativeForm, 'selling_plan')?.value;
      if (this.productData.requiresSellingPlan && (!plan || plan === '0')) {
        this.showStatus('Please choose a subscription option first.', true);
        this.focusProductOptions();
        return;
      }
      if (!this.nativeForm.noValidate && !this.nativeForm.reportValidity()) {
        this.showStatus('Please complete the required product options first.', true);
        return;
      }
      this.showStatus('');
      this.awaitingCart = true;
      this.clickLocked = true;
      this.syncPurchase();
      // Click the REAL existing button. Do not issue a second fetch, rewrite
      // form fields, bypass application handlers, or force a selling plan.
      this.nativeButton.click();
      this.queueSync();
      clearTimeout(this.clickTimer);
      this.clickTimer = setTimeout(() => {
        this.clickLocked = false;
        this.queueSync();
      }, 400);
    }

    focusProductOptions() {
      const area = this.nativeForm?.closest('[data-hh-product-information], .prd, product-info') || this.nativeForm;
      if (!area) return;
      area.scrollIntoView({ behavior: this.motionQuery.matches ? 'auto' : 'smooth', block: 'center' });
      const control = area.querySelector('input[type="radio"]:not(:disabled), select:not(:disabled)') || this.nativeButton;
      control?.focus({ preventScroll: true });
    }

    onCartUpdated() {
      if (!this.awaitingCart) return;
      this.awaitingCart = false;
      this.showStatus('Added to basket.');
      this.statusTimer = setTimeout(() => this.showStatus(''), 6000);
      this.queueSync();
    }

    initImages() {
      if (!this.viewport || !this.group || !this.group.children.length) return;
      this.listen(this.pauseButton, 'click', () => {
        this.userPaused = !this.userPaused;
        this.setText(this.pauseButton.querySelector('[data-pause-label]'), this.userPaused ? 'Play images' : 'Pause images');
        this.updatePlayback();
      });
      this.listen(this.media, 'mouseenter', () => { this.hovered = true; this.updatePlayback(); });
      this.listen(this.media, 'mouseleave', () => { this.hovered = false; this.updatePlayback(); });
      this.listen(this.viewport, 'focus', () => { this.viewportFocused = true; this.updatePlayback(); });
      this.listen(this.viewport, 'blur', () => { this.viewportFocused = false; this.updatePlayback(); });
      this.listen(document, 'visibilitychange', () => this.updatePlayback());
      this.listen(this.motionQuery, 'change', () => this.queueLoop());
      this.listen(this.hoverQuery, 'change', () => this.updatePlayback());
      this.listen(window, 'resize', () => this.queueLoop(), { passive: true });
      this.listen(document, 'shopify:block:select', event => {
        if (String(event.detail?.sectionId) !== this.dataset.sectionId) return;
        this.dataset.editorSelected = 'true';
        this.updatePlayback();
        const item = [...this.group.children].find(node => node.dataset.blockId === String(event.detail?.blockId));
        if (item) this.viewport.scrollLeft = Math.max(0, item.offsetLeft - 60);
      });
      this.listen(document, 'shopify:block:deselect', event => {
        if (String(event.detail?.sectionId) !== this.dataset.sectionId) return;
        this.dataset.editorSelected = 'false';
        this.viewport.scrollLeft = 0;
        this.updatePlayback();
      });
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => this.queueLoop());
        this.resizeObserver.observe(this.viewport);
        this.resizeObserver.observe(this.group);
      }
      if ('IntersectionObserver' in window) {
        this.intersectionObserver = new IntersectionObserver(entries => {
          this.inView = entries.some(entry => entry.isIntersecting);
          if (this.inView) this.loadLoopImages();
          this.updatePlayback();
        }, { rootMargin: '150px' });
        this.intersectionObserver.observe(this);
      } else {
        this.inView = true;
      }
      this.buildLoop();
    }

    queueLoop() {
      cancelAnimationFrame(this.loopFrame);
      this.loopFrame = requestAnimationFrame(() => {
        if (this.isConnected) this.buildLoop();
      });
    }

    buildLoop() {
      if (!this.viewport || !this.group) return;
      const width = this.group.getBoundingClientRect().width;
      const viewportWidth = this.viewport.clientWidth;
      const enabled = this.dataset.autoplay === 'true' && !this.motionQuery.matches;
      const key = `${enabled}:${width.toFixed(2)}:${viewportWidth}`;
      if (key === this.lastLoopKey) { this.updatePlayback(); return; }
      this.lastLoopKey = key;
      this.track.querySelectorAll('[data-clone-group]').forEach(node => node.remove());
      this.dataset.loopReady = 'false';
      this.pauseButton.hidden = true;
      if (!enabled || width <= 0 || viewportWidth <= 0) {
        this.updatePlayback();
        return;
      }
      // Enough identical groups to cover even a very wide viewport with ONE
      // uploaded image. The animation travels exactly one complete group.
      const copies = Math.ceil(viewportWidth / width) + 1;
      for (let index = 0; index < copies; index += 1) {
        const clone = this.group.cloneNode(true);
        clone.removeAttribute('data-original-group');
        clone.setAttribute('data-clone-group', '');
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('inert', '');
        [clone, ...clone.querySelectorAll('*')].forEach(node => {
          node.removeAttribute('id');
          node.removeAttribute('data-block-id');
          [...node.attributes].forEach(attribute => {
            if (attribute.name.startsWith('data-shopify-editor')) node.removeAttribute(attribute.name);
          });
          if (node.tagName === 'IMG') node.setAttribute('alt', '');
        });
        this.track.appendChild(clone);
      }
      const speed = Math.max(10, Number(this.dataset.speed) || 40);
      this.style.setProperty('--hhpb-distance', width + 'px');
      this.style.setProperty('--hhpb-duration', (width / speed) + 's');
      this.viewport.scrollLeft = 0;
      this.dataset.loopReady = 'true';
      this.pauseButton.hidden = false;
      if (this.inView) this.loadLoopImages();
      this.updatePlayback();
    }

    loadLoopImages() {
      // Load the short image set when approaching the viewport, not on every
      // page load. Repeated images reuse the same Shopify CDN image URLs.
      this.track?.querySelectorAll('img[loading="lazy"]').forEach(image => { image.loading = 'eager'; });
    }

    updatePlayback() {
      const hoverPause = this.dataset.hoverPause === 'true' && this.hoverQuery.matches && this.hovered;
      this.dataset.running = String(this.dataset.loopReady === 'true' && this.inView &&
        !document.hidden && !this.motionQuery.matches && !this.userPaused &&
        !hoverPause && !this.viewportFocused && this.dataset.editorSelected !== 'true');
    }
  }

  customElements.define('hh-product-banner', HHProductBanner);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
